import * as h2Api from '../../h2Api'

export const SELECT_TOOL = 'SELECT_TOOL'
export const DISMISS_TOOL = 'DISMISS_TOOL'
export const RATE_TOOL = 'RATE_TOOL'
export const SAVE_RATE_TOOL = 'SAVE_RATE_TOOL'

export const selectTool = t => dispatch => {
  return dispatch({ type: SELECT_TOOL, tool: t })
}

export const dismissTool = () => dispatch => {
  return dispatch({ type: DISMISS_TOOL })
}

export const saveToolRating = (tool, ratingType) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const name = getState().early.gameboard.userInfo

  return dispatch(
    h2Api.post(`/early/${loadedGameId}/rating`, {
      objectType: 'tool',
      objectId: tool.id,
      rating: ratingType
    })({ type: SAVE_RATE_TOOL })
  )
}

export const rateTool = (tool, ratingType) => dispatch => {
  console.log('RATING', tool, ratingType)
  dispatch({
    type: RATE_TOOL,
    toolId: tool.id,
    rating: ratingType
  })

  return Promise.resolve(true)
}
